
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import SingleCustomerReport from "../components/singleCustomerReport";
import Footer from "../components/footer";

function SingleCustomerReportPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < SingleCustomerReport /> 
    <Footer />
    </div>
  </div>
  // <Login/>
  );
}
export default SingleCustomerReportPage;
